<template>
    <div class="focus-plate-box">
        <div class="preview-opration">
            <el-button style="margin-left: 30px" icon="el-icon-plus" type="danger" @click="openCreatePlateDialog">新增板块
            </el-button>
        </div>
        <div class="plate-list">
            <el-table class="plate-table" border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                      :data="plateList" :row-key="() => Math.random()">
                <el-table-column prop="orderNum" label="序号"></el-table-column>
                <el-table-column prop="logoUrl" label="板块图标" width="100px">
                    <template slot-scope="scope">
                        <img style="width: 50px; height: 50px" :src="scope.row.logoUrl"/>
                    </template>
                </el-table-column>
                <el-table-column prop="nameJson" label="板块名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="introductionJson" label="板块介绍" show-overflow-tooltip></el-table-column>
                <el-table-column prop="owner" label="版主" show-overflow-tooltip></el-table-column>
                <el-table-column prop="maintainer" label="维护者" show-overflow-tooltip></el-table-column>
                <el-table-column prop="unscrambleJson" label="解读(一句话简介)" show-overflow-tooltip></el-table-column>
                <el-table-column prop="heatLevel" label="热度级别" show-overflow-tooltip></el-table-column>
                <el-table-column prop="heatValue" label="热度值" show-overflow-tooltip></el-table-column>
                <el-table-column prop="countUnitsJson" label="统计单位" show-overflow-tooltip></el-table-column>
                <el-table-column prop="activated" label="是否激活" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.activated" active-color="#13ce66" disabled=""
                                   inactive-color="#ff4949"></el-switch>
                    </template>
                </el-table-column>
                <el-table-column prop="hot" label="是否热门" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.hot" active-color="#13ce66" disabled=""
                                   inactive-color="#ff4949"></el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="统计时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.countTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="创建时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.createTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="修改时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.updateTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="300">
                    <template slot-scope="scope">
                        <el-button type="primary" @click="platePairConfig(scope.row)">交易对配置</el-button>
                        <el-button type="danger" @click="updatePlateDialog(scope.row)">修改</el-button>
                        <el-button type="danger" @click="deletePlate(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="margin-top: 30px"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="params.page"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="params.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </div>

        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="60%" @close="clearData"
                   :close-on-click-modal="false">
            <el-form label-width="150px" :model="plateData" :rules="plateRules" ref="plateForm">
                <el-form-item label="排序号：" prop="orderNum">
                    <el-input-number v-model="plateData.orderNum" :min="1" :max="10000000"
                                     label="排序号"></el-input-number>
                </el-form-item>
                <el-form-item label="是否激活：" prop="activated">
                    <el-switch v-model="plateData.activated" active-color="#13ce66"
                               inactive-color="#ff4949"></el-switch>
                </el-form-item>
                <el-form-item label="是否热门：" prop="hot">
                    <el-switch v-model="plateData.hot" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                </el-form-item>
                <el-form-item label="板块图标：" prop="logoUrl">
                    <UploadMoulde :value="plateData.logoUrl" :limitNumber="1" v-on:input="getSucessInfo"
                                  ref="childUpload"></UploadMoulde>
                </el-form-item>
                <el-form-item label="版主：" prop="owner">
                    <el-input v-model="plateData.owner" placeholder="版主" style="width: 500px"></el-input>
                </el-form-item>
                <el-form-item label="维护者：" prop="maintainer">
                    <el-input v-model="plateData.maintainer" placeholder="维护者" style="width: 500px"></el-input>
                </el-form-item>
                <el-form-item label="关联板块：">
                    <div>
                        <el-tag :key="plate.id" v-for="plate in selectPlate" closable
                                :disable-transitions="false" @close="handlePlateClose(plate)"
                                style="max-width: 200px;overflow: hidden;margin-right: 20px;margin-bottom: -11px">
                            {{plate.nameJson?JSON.parse(plate.nameJson).zh:''}}
                        </el-tag>
                        <el-button class="button-new-tag" size="small" @click="openChoosePlateDialog">+ 选择板块
                        </el-button>
                    </div>
                </el-form-item>
                <el-form-item label="板块活动：">
                    <div>
                        <el-tag :key="activity.id" v-for="activity in selectActivity" closable
                                :disable-transitions="false" @close="handleActivityClose(activity)"
                                style="max-width: 200px;overflow: hidden;margin-right: 20px;margin-bottom: -11px">
                            {{activity.recommendTitle}}
                        </el-tag>
                        <el-button class="button-new-tag" size="small" @click="openChooseActivityDialog">+ 选择活动
                        </el-button>
                    </div>
                </el-form-item>
                <el-form-item label="板块标签：">
                    <div>
                        <el-tag v-for="(tag,index) in dynamicTagsObj" closable :key="tag.index"
                                :disable-transitions="false"
                                @close="handleClose(tag)" style="margin-right: 20px">
                            {{tag.zh}}
                        </el-tag>
                        <el-button class="button-new-tag" size="small" @click="openChooseLabelDialog">+ 选择标签</el-button>
                    </div>
                </el-form-item>
                <el-form-item label="板块名称：" prop="name">
                    <div v-for="lang in languages" :key="lang.value" class="introduction-editor">
                        <div class="introduction-editor-header">{{ lang.label }}<span v-if="lang.value=='zh'"
                                                                                      style="color: red">* 中文必填,其他语言选填</span>
                        </div>
                        <el-input :value="nameJson[lang.value]" maxlength="150"
                                  @change="handleNameJsonChange(lang.value, $event)"></el-input>
                    </div>
                </el-form-item>
                <el-form-item label="板块介绍：" prop="introduction">
                    <div v-for="lang in languages" :key="lang.value" class="introduction-editor">
                        <div class="introduction-editor-header">{{ lang.label }}简介 （最多300个字符）<span
                                v-if="lang.value=='zh'" style="color: red">* 中文必填,其他语言选填</span></div>
                        <el-input :value="introductionJson[lang.value]" type="textarea" :rows="6" maxlength="300"
                                  @change="handleIntroductionJsonChange(lang.value, $event)"></el-input>
                    </div>
                </el-form-item>
                <el-form-item label="解读：" prop="unscramble">
                    <div v-for="lang in languages" :key="lang.value" class="introduction-editor">
                        <div class="introduction-editor-header">{{ lang.label }}简介 （最多150个字符）<span
                                v-if="lang.value=='zh'" style="color: red">* 中文必填,其他语言选填</span></div>
                        <el-input :value="unscrambleJson[lang.value]" type="textarea" :rows="3" maxlength="150"
                                  @change="handleUnscrambleJsonChange(lang.value, $event)"></el-input>
                    </div>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button type="danger" :loading="loading" @click="addPlateDialog">确 定</el-button>
            </span>
        </el-dialog>

        <!--标签弹框-->
        <el-dialog title="选择标签" :visible.sync="labelDialogVisible" width="40%">
            <div>
                <div>
                    <el-tabs v-model="activeName" @tab-click="handleLabelClick"
                             style="width: 80%;display: inline-block">
                        <el-tab-pane v-for="item in labelArry" :key="item.value" :label="item.label" :name="item.value"></el-tab-pane>
                    </el-tabs>
                </div>
                <div style="margin-top: 20px">
                    <el-input placeholder="请输入名称" v-model="queryLabel.labelName" prefix-icon="el-icon-search"
                              style="width: 80%"></el-input>
                    <el-button style="margin-left: 10px" type="danger" @click="searchDialogLabel">搜索</el-button>
                </div>
                <div style="margin-top: 20px;margin-bottom: 50px;max-height: 400px">
                    <el-tag style="margin-right: 5px;cursor: default;margin-bottom: 5px" v-for="item in labelListDialog"
                            :key="item.id"
                            @click.native="chooseLabel(item)" :type="getTagType(item.labelName)">
                        {{item.labelName}}
                    </el-tag>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="labelDialogVisible=false">确 定</el-button>
            </span>
        </el-dialog>

        <!--活动弹框-->
        <el-dialog title="选择活动" :visible.sync="activityDialogVisible" width="40%">
            <div>
                <el-input v-model="activityParams.recommendName" style="margin-bottom: 10px" placeholder="输入关键字搜索">
                    <el-button slot="append" icon="el-icon-search" @click="searchActivity"></el-button>
                </el-input>
                <el-table border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                          :data="recommendPositionList" :row-key="() => Math.random()">
                    <el-table-column width="55">
                        <template slot-scope="scope">
                            <el-checkbox v-model="scope.row.checked"
                                         @change="handleSelectionChange(scope.row,$event)"></el-checkbox>
                        </template>
                    </el-table-column>
                    <el-table-column prop="recommendTitle" label="名称" show-overflow-tooltip></el-table-column>
                </el-table>
                <el-pagination style="margin-top: 30px"
                               @size-change="handleActivitySizeChange"
                               @current-change="handleActivityCurrentChange"
                               :current-page="activityParams.page"
                               :page-sizes="[1,10, 20, 50, 100,500,1000,2000]"
                               :page-size="activityParams.size"
                               layout="total, sizes, prev, pager, next, jumper"
                               :total="activityTotal">
                </el-pagination>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="chooseActivity">确 定</el-button>
            </span>
        </el-dialog>

        <!--板块弹框-->
        <el-dialog title="选择板块" :visible.sync="plateDialogVisible" width="40%">
            <div>
                <el-table border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                          :data="selectPlateList" :row-key="() => Math.random()">
                    <el-table-column width="55">
                        <template slot-scope="scope">
                            <el-checkbox v-model="scope.row.checked" :disabled="plateData.id==scope.row.id"
                                         @change="handleSelectionPlateChange(scope.row,$event)"></el-checkbox>
                        </template>
                    </el-table-column>
                    <el-table-column label="名称" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span> {{scope.row.nameJson?JSON.parse(scope.row.nameJson).zh:''}}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination style="margin-top: 30px"
                               @size-change="handlePlateSizeChange"
                               @current-change="handlePlateCurrentChange"
                               :current-page="selectPlateParams.page"
                               :page-sizes="[1,10, 20, 50, 100,500,1000,2000]"
                               :page-size="selectPlateParams.size"
                               layout="total, sizes, prev, pager, next, jumper"
                               :total="plateTotal">
                </el-pagination>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="choosePlate">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import '../store';
    import api from '../api';
    import LANGUAGES from "../../../common/languages_code";
    import UploadMoulde from "../../../components/upload/indexLimit.vue";
    import {LABELTYPE} from "../../cms/common/constants";

    export default {
        name: 'PlateManage',
        components: {
            UploadMoulde
        },
        data() {
            return {
                plateList: [],
                total: 0,
                params: {page: 1, size: 10},
                dialogVisible: false,
                dialogTitle: "新增",
                currOpration: "1", //1-新增，2-修改
                loading: false,
                plateData: {
                    id: "",
                    name: "",
                    logoUrl: "",
                    introduction: "",
                    owner: "",
                    maintainer: "",
                    unscramble: "",
                    activityIdList: "",
                    labels: "",
                    relatedIdList: "",
                    activated: false,
                    hot: false,
                    orderNum: 0
                },
                plateRules: {
                    "name": [{required: true, message: "板块名称不能为空"}],
                    "logoUrl": [{required: true, message: "logoUrl不能为空"}],
                    "introduction": [{required: true, message: "板块介绍不能为空"}],
                    "orderNum": [{required: true, message: "序号不能为空"}],
                    "owner": [{required: true, message: "版主不能为空"}],
                    "maintainer": [{required: true, message: "维护者不能为空"}],
                    "unscramble": [{required: true, message: "解读不能为空"}],
                },
                languages: Object.keys(LANGUAGES).map(lang => ({
                    label: LANGUAGES[lang],
                    value: lang
                })),
                nameJson: {},
                introductionJson: {},
                unscrambleJson: {},
                labelDialogVisible: false,  //弹框是否显示
                activeName: "PRODUCT_LABEL", //激活的tab
                // dynamicTags: [], //选择的标签id
                dynamicTagsObj: [], //选择的标签对象
                labelListDialog: [], //对话框选择标签数据列表
                queryLabel: { //对话框查询参数
                    labelName: "",
                    labelType: "",
                    page: 1,
                    size: 1000
                },
                activityDialogVisible: false,
                recommendPositionList: [],
                activityTotal: 0,
                activityParams: { //查询参数
                    recommendType: "PLATE_HOT_ACTIVITY",
                    recommendName: "",
                    page: 1,
                    size: 1000
                },
                selectActivity: [],
                selectActivityId: [],
                selectPlateParams: {page: 1, size: 10},
                plateDialogVisible: false,
                selectPlateList: [],
                plateTotal: 0,
                selectPlate: [],
                selectPlateId: [],
                labelArry: LABELTYPE
            }
        },
        methods: {
            initData() {
                Object.keys(LANGUAGES).map(lang => {
                    this.nameJson[lang] = "";
                    this.introductionJson[lang] = "";
                    this.unscrambleJson[lang] = "";
                })
            },
            handleNameJsonChange(lang, value) {
                this.nameJson[lang] = value;
                this.plateData.name = JSON.stringify(this.nameJson);
            },
            handleIntroductionJsonChange(lang, value) {
                this.introductionJson[lang] = value;
                this.plateData.introduction = JSON.stringify(this.introductionJson);
            },
            handleUnscrambleJsonChange(lang, value) {
                this.unscrambleJson[lang] = value;
                this.plateData.unscramble = JSON.stringify(this.unscrambleJson);
            },
            handleLabelClick() {
                this.queryLabel.labelName = "";
                this.queryLabel.labelType = this.activeName;
                this.getDialogLabelList(this.queryLabel);
            },
            searchDialogLabel() {
                this.queryLabel.labelType = this.activeName;
                this.getDialogLabelList(this.queryLabel);
            },
            handleClose(tag) {
                // this.dynamicTags.splice(this.dynamicTags.indexOf(tag.id + ""), 1);
                for (let i = 0; i < this.dynamicTagsObj.length; i++) {
                    if (this.dynamicTagsObj[i].zh == tag.zh) {
                        this.dynamicTagsObj.splice(i, 1);
                        break;
                    }
                }
            },
            getTagType(name) {
                // id = id + "";
                for (let i = 0; i < this.dynamicTagsObj.length; i++) {
                    if (this.dynamicTagsObj[i].zh == name) {
                        return "danger"
                    }
                }
                return "info";
            },
            chooseLabel(item) {
                // let id = item.id + "";
                // this.dynamicTags.indexOf(id) == -1 ? this.dynamicTags.push(id) : this.dynamicTags.splice(this.dynamicTags.indexOf(id), 1);
                for (let i = 0; i < this.dynamicTagsObj.length; i++) {
                    if (this.dynamicTagsObj[i].zh == item.labelName) {
                        this.dynamicTagsObj.splice(i, 1);
                        return;
                    }
                }
                let nameJson = item.nameJson ? JSON.parse(item.nameJson) : {}
                nameJson.zh = item.labelName;
                this.dynamicTagsObj.push(nameJson)
            },
            getDialogLabelList(query) {
                api.getLabelList(query).then(({data}) => {
                    this.labelListDialog = data.records;
                });
            },
            getRecommendPositionList(query) {
                api.getRecommendPositionList(query).then(({data}) => {
                    this.recommendPositionList = data.records;
                    this.activityTotal = data.total;
                    this.toggleSelection(this.selectActivity);
                });
            },
            getFocusPlateList(query) {
                api.getFocusPlateList(query).then(({data}) => {
                    this.total = data.totalCount;
                    this.plateList = data.list;
                });
            },
            getSelectFocusPlateList() {
                api.getFocusPlateList(this.selectPlateParams).then(({data}) => {
                    this.plateTotal = data.totalCount;
                    this.selectPlateList = data.list;
                    this.togglePlateSelection(this.selectPlate);
                });
            },
            // getPlateDetailLabelList(labelIds) {
            //     let ids = [];
            //     for (let labelId in labelIds) {
            //         ids.push(labelId.id);
            //     }
            //     api.getPlateDetailLabelList({labelIds: ids}).then(({data}) => {
            //         this.dynamicTagsObj = data; //选择的标签对象
            //     });
            // },
            getRecommendPositionByIds(activityIds) {
                api.getRecommendPositionByIds({ids: activityIds}).then(({data}) => {
                    this.selectActivity = data; //选择的活动对象
                });
            },
            getPlateByIds(plateIds) {
                api.getFocusPlateBatchList({ids: plateIds}).then(({data}) => {
                    this.selectPlate = data; //选择的板块对象
                });
            },
            openChooseLabelDialog() {
                this.queryLabel.labelName = "";
                this.queryLabel.labelType = this.activeName;
                this.getDialogLabelList(this.queryLabel);
                this.labelDialogVisible = true;
            },
            openChooseActivityDialog() {
                this.getRecommendPositionList(this.activityParams);
                this.activityDialogVisible = true;

            },
            openChoosePlateDialog() {
                this.getSelectFocusPlateList();
                this.plateDialogVisible = true;

            },
            openCreatePlateDialog() {
                this.currOpration = "1"
                this.dialogVisible = true;
            },
            updatePlateDialog(row) {
                this.currOpration = "2";
                api.getFocusPlateInfo({id: row.id}).then(({data}) => {
                    this.plateData = {
                        id: data.id,
                        name: data.nameJson,
                        logoUrl: data.logoUrl,
                        introduction: data.introductionJson,
                        owner: data.owner,
                        maintainer: data.maintainer,
                        unscramble: data.unscrambleJson,
                        activityIdList: data.activityIdList,
                        labels: data.labels,
                        relatedIdList: data.relatedIdList,
                        activated: data.activated,
                        hot: data.hot,
                        orderNum: data.orderNum
                    };

                    this.nameJson = data.nameJson ? JSON.parse(data.nameJson) : {};
                    this.introductionJson = data.introductionJson ? JSON.parse(data.introductionJson) : {};
                    this.unscrambleJson = data.unscrambleJson ? JSON.parse(data.unscrambleJson) : {};
                    this.dynamicTagsObj = data.labels ? JSON.parse(data.labels) : []; //选择的标签id
                    this.selectActivityId = data.activityIdList ? JSON.parse(data.activityIdList) : [];
                    this.selectPlateId = data.relatedIdList ? JSON.parse(data.relatedIdList) : [];
                    // this.getPlateDetailLabelList(this.dynamicTagsObj);
                    this.getRecommendPositionByIds(this.selectActivityId.join(","));
                    this.getPlateByIds(this.selectPlateId.join(","));
                    this.dialogVisible = true;
                });
            },
            addPlateDialog() {
                this.plateData.labels = JSON.stringify(this.dynamicTagsObj);
                this.plateData.activityIdList = JSON.stringify(this.selectActivityId);
                this.plateData.relatedIdList = JSON.stringify(this.selectPlateId);
                this.$refs["plateForm"].validate(valid => {
                    if (valid) {
                        this.loading = true;
                        if (this.currOpration == "1") {
                            api.addFocusPlate(this.plateData).then(() => {
                                this.$message.success("创建成功！");
                                this.getFocusPlateList(this.params);
                                this.loading = false;
                                this.dialogVisible = false;
                            });
                        } else if (this.currOpration == "2") {
                            api.updateFocusPlate(this.plateData).then(() => {
                                this.$message.success("修改成功！");
                                this.getFocusPlateList(this.params);
                                this.loading = false;
                                this.dialogVisible = false;
                            });
                        }
                        setTimeout(() => {
                            this.loading = false;
                        }, 1000);
                    }
                });
            },
            deletePlate(id) {
                this.$confirm('确认此删除吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.deleteFocusPlate({id: id}).then(({data}) => {
                        this.$message.success('操作成功！');
                        this.getFocusPlateList(this.params);
                    });
                }).catch(() => {
                });
            },
            platePairConfig(row) {
                this.$router.push({
                    path: '/home/focus/PlatePair',
                    query: {
                        id: row.id,
                        name: row.nameJson ? JSON.parse(row.nameJson).zh : ''
                    }
                })
                ;
            },
            choosePlate() {
                this.plateDialogVisible = false;
            },
            handleSelectionPlateChange(row, val) {
                if (val == true) {
                    this.selectPlate.push(row);
                    this.selectPlateId.push(row.id + "");
                } else {
                    this.handlePlateClose(row);
                }
            },
            handlePlateClose(row) {
                this.selectPlateId.splice(this.selectPlateId.indexOf(row.id + ""), 1);
                for (let i = 0; i < this.selectPlate.length; i++) {
                    if (this.selectPlate[i].id == row.id) {
                        this.selectPlate.splice(i, 1);
                        break;
                    }
                }
            },
            togglePlateSelection(rows) {
                if (rows) {
                    this.selectPlateList.forEach(item => {
                        rows.forEach(row => {
                            if (item.id == row.id) {
                                item.checked = true;
                            }
                        });
                    });
                }
            },
            handlePlateClose(row) {
                this.selectPlateId.splice(this.selectPlateId.indexOf(row.id + ""), 1);
                for (let i = 0; i < this.selectPlate.length; i++) {
                    if (this.selectPlate[i].id == row.id) {
                        this.selectPlate.splice(i, 1);
                        break;
                    }
                }
            },
            chooseActivity() {
                this.activityDialogVisible = false;
            },
            handleSelectionChange(row, val) {
                if (val == true) {
                    this.selectActivity.push(row);
                    this.selectActivityId.push(row.id + "");
                } else {
                    this.handleActivityClose(row);
                }
            },
            handleActivityClose(row) {
                this.selectActivityId.splice(this.selectActivityId.indexOf(row.id + ""), 1);
                for (let i = 0; i < this.selectActivity.length; i++) {
                    if (this.selectActivity[i].id == row.id) {
                        this.selectActivity.splice(i, 1);
                        break;
                    }
                }
            },
            toggleSelection(rows) {
                if (rows) {
                    this.recommendPositionList.forEach(item => {
                        rows.forEach(row => {
                            if (item.id == row.id) {
                                item.checked = true;
                            }
                        });
                    });
                }
            },
            handleSizeChange(val) {
                this.params.size = val;
                this.getFocusPlateList(this.params);
            },
            handleCurrentChange(val) {
                this.params.page = val;
                this.getFocusPlateList(this.params);
            },
            handleActivitySizeChange(val) {
                this.activityParams.size = val;
                this.getRecommendPositionList(this.activityParams);
            },
            handleActivityCurrentChange(val) {
                this.activityParams.page = val;
                this.getRecommendPositionList(this.activityParams);
            },
            handlePlateSizeChange(val) {
                this.selectPlateParams.size = val;
                this.getSelectFocusPlateList();
            },
            handlePlateCurrentChange(val) {
                this.selectPlateParams.page = val;
                this.getSelectFocusPlateList();
            },
            searchActivity() {
                this.activityParams.page = 1;
                this.getRecommendPositionList(this.activityParams);
            },
            getSucessInfo(data) {
                //上传成功
                this.plateData.logoUrl = data;
            },
            clearData() {
                this.$refs.childUpload.handleRemove();
                this.dialogTitle = "新增";
                this.currOpration = "1"; //1-新增，2-修改
                this.loading = false;
                this.plateData = {
                    id: "",
                    name: "",
                    logoUrl: "",
                    introduction: "",
                    owner: "",
                    maintainer: "",
                    unscramble: "",
                    activityIdList: "",
                    labels: "",
                    relatedIdList: "",
                    activated: false,
                    hot: false,
                    orderNum: 0
                };

                this.nameJson = {};
                this.introductionJson = {};
                this.unscrambleJson = {};
                this.activeName = "PRODUCT_LABEL"; //激活的tab
                this.dynamicTagsObj = []; //选择的标签对象
                this.labelListDialog = []; //对话框选择标签数据列表
                this.queryLabel = { //对话框查询参数
                    labelName: "",
                    labelType: "",
                    page: 1,
                    size: 1
                };
                this.recommendPositionList = [];
                this.activityTotal = 0;
                this.activityParams = { //查询参数
                    recommendType: "PLATE_HOT_ACTIVITY",
                    recommendName: "",
                    page: 1,
                    size: 1000
                };
                this.selectActivity = [];
                this.selectActivityId = [];
                this.selectPlateList = [];
                this.plateTotal = 0;
                this.selectPlate = [];
                this.selectPlateId = [];
            }
        },
        created() {
            this.initData();
            this.getFocusPlateList(this.params);
            this.getRecommendPositionList(this.activityParams);
        }
    };
</script>

<style lang="less" scoped>
    .focus-plate-box {
        .preview-opration {
            float: right;
        }

        .plate-list {
            border: 1px solid #f2ece2;
            clear: both;
            width: 100%;
            .plate-table {
                margin-top: 30px;
            }
        }
    }
</style>

